import { render, staticRenderFns } from "./InstantPlayer.vue?vue&type=template&id=8c9f677e&scoped=true"
import script from "./InstantPlayer.vue?vue&type=script&setup=true&lang=js"
export * from "./InstantPlayer.vue?vue&type=script&setup=true&lang=js"
import style0 from "./InstantPlayer.vue?vue&type=style&index=0&id=8c9f677e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c9f677e",
  null
  
)

export default component.exports